import notificatorConstants from './constants';

const notificatorActions = {
  showSuccessNotification: message => ({
    type: notificatorConstants.SHOW_SUCCESS_NOTIFICATION,
    payload: {
      id: new Date().getTime(),
      message
    }
  }),
  showErrorNotification: message => ({
    type: notificatorConstants.SHOW_ERROR_NOTIFICATION,
    payload: {
      id: new Date().getTime(),
      message
    }
  })
};

export default notificatorActions;
